export default __webpack_public_path__ + "static/media/package_for_return_to_sender.17936cc8.png";